{
    "BSB33": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "key": "BSB33",
        "tag": "goodspawn"
    },
    "tOXD0": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "key": "tOXD0",
        "tag": "goodspawn"
    },
    "dXbM8": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 8,
            "y": 7,
            "z": 1
        },
        "key": "dXbM8",
        "tag": "goodspawn"
    },
    "ohd8q": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 9,
            "y": 7,
            "z": 1
        },
        "key": "ohd8q",
        "tag": "goodspawn"
    },
    "TV9mw": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "key": "TV9mw",
        "tag": "badspawn"
    },
    "Rw8TL": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "key": "Rw8TL",
        "tag": "badspawn"
    },
    "zP9y_": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "zP9y_",
        "tag": "badspawn"
    },
    "GniA-": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "GniA-",
        "tag": "badspawn"
    },
    "ugJYe": {
        "position": {
            "x": 10,
            "y": 4,
            "z": 1
        },
        "key": "ugJYe",
        "tag": "badspawn"
    },
    "rt3C9": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "rt3C9",
        "tag": "lootspawn"
    },
    "fd_e9": {
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "key": "fd_e9",
        "tag": "lootspawn"
    },
    "FLKym": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "key": "FLKym",
        "tag": "lootspawn"
    },
    "Mk11M": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "Mk11M",
        "tag": "lootspawn"
    },
    "N_JZs": {
        "position": {
            "x": 5,
            "y": 6,
            "z": 1
        },
        "key": "N_JZs",
        "tag": "lootspawn"
    },
    "PJ6kz": {
        "position": {
            "x": 10,
            "y": 6,
            "z": 1
        },
        "key": "PJ6kz",
        "tag": "lootspawn"
    },
    "EcsjI": {
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        },
        "key": "EcsjI",
        "tag": "badspawn"
    },
    "inTYF": {
        "position": {
            "x": 4,
            "y": 3,
            "z": 1
        },
        "key": "inTYF",
        "tag": "badspawn"
    },
    "G2rw_": {
        "position": {
            "x": 11,
            "y": 3,
            "z": 1
        },
        "key": "G2rw_",
        "tag": "badspawn"
    },
    "Rm7Z6": {
        "position": {
            "x": 11,
            "y": 4,
            "z": 1
        },
        "key": "Rm7Z6",
        "tag": "badspawn"
    },
    "ZpdoL": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 6,
            "y": 11,
            "z": 1
        },
        "key": "ZpdoL",
        "tag": "goodspawn"
    },
    "POZei": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 7,
            "y": 11,
            "z": 1
        },
        "key": "POZei",
        "tag": "goodspawn"
    },
    "cdcEk": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 8,
            "y": 11,
            "z": 1
        },
        "key": "cdcEk",
        "tag": "goodspawn"
    },
    "5R8pr": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 9,
            "y": 11,
            "z": 1
        },
        "key": "5R8pr",
        "tag": "goodspawn"
    },
    "4w3ES": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 7,
            "y": 20,
            "z": 1
        },
        "key": "4w3ES",
        "tag": "goodspawn"
    },
    "zohqX": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 6,
            "y": 20,
            "z": 1
        },
        "key": "zohqX",
        "tag": "goodspawn"
    },
    "pZkID": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 8,
            "y": 20,
            "z": 1
        },
        "key": "pZkID",
        "tag": "goodspawn"
    },
    "7CoGc": {
        "direction": {
            "y": -2,
            "x": 1
        },
        "position": {
            "x": 9,
            "y": 20,
            "z": 1
        },
        "key": "7CoGc",
        "tag": "goodspawn"
    },
    "vzt-r": {
        "position": {
            "x": 4,
            "y": 15,
            "z": 1
        },
        "key": "vzt-r",
        "tag": "badspawn"
    },
    "oX03e": {
        "position": {
            "x": 5,
            "y": 14,
            "z": 1
        },
        "key": "oX03e",
        "tag": "badspawn"
    },
    "ynk-l": {
        "position": {
            "x": 3,
            "y": 13,
            "z": 1
        },
        "key": "ynk-l",
        "tag": "badspawn"
    },
    "7Cxa-": {
        "position": {
            "x": 12,
            "y": 13,
            "z": 1
        },
        "key": "7Cxa-",
        "tag": "badspawn"
    },
    "JALSt": {
        "position": {
            "x": 12,
            "y": 15,
            "z": 1
        },
        "key": "JALSt",
        "tag": "badspawn"
    },
    "NEcUF": {
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "key": "NEcUF",
        "tag": "badspawn"
    },
    "WKiWe": {
        "position": {
            "x": 6,
            "y": 15,
            "z": 1
        },
        "key": "WKiWe",
        "tag": "badspawn"
    },
    "ufjWk": {
        "position": {
            "x": 8,
            "y": 15,
            "z": 1
        },
        "key": "ufjWk",
        "tag": "badspawn"
    },
    "ydudl": {
        "position": {
            "x": 11,
            "y": 15,
            "z": 1
        },
        "key": "ydudl",
        "tag": "badspawn"
    },
    "uMqWj": {
        "position": {
            "x": 5,
            "y": 12,
            "z": 1
        },
        "key": "uMqWj",
        "tag": "lootspawn"
    },
    "CaZyK": {
        "position": {
            "x": 6,
            "y": 14,
            "z": 1
        },
        "key": "CaZyK",
        "tag": "lootspawn"
    },
    "K4fEZ": {
        "position": {
            "x": 7,
            "y": 15,
            "z": 1
        },
        "key": "K4fEZ",
        "tag": "lootspawn"
    },
    "6Cyvl": {
        "position": {
            "x": 8,
            "y": 13,
            "z": 1
        },
        "key": "6Cyvl",
        "tag": "lootspawn"
    },
    "9zb3w": {
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "key": "9zb3w",
        "tag": "lootspawn"
    },
    "RiWiP": {
        "position": {
            "x": 10,
            "y": 12,
            "z": 1
        },
        "key": "RiWiP",
        "tag": "lootspawn"
    },
    "D8FTQ": {
        "position": {
            "x": 3,
            "y": 15,
            "z": 1
        },
        "key": "D8FTQ",
        "tag": "lootspawn"
    },
    "8B9-d": {
        "position": {
            "x": 4,
            "y": 14,
            "z": 1
        },
        "key": "8B9-d",
        "tag": "lootspawn"
    },
    "Yq1Pl": {
        "position": {
            "x": 10,
            "y": 15,
            "z": 1
        },
        "key": "Yq1Pl",
        "tag": "lootspawn"
    },
    "Y9Zi5": {
        "position": {
            "x": 12,
            "y": 20,
            "z": 1
        },
        "key": "Y9Zi5",
        "tag": "badspawn"
    },
    "UrK_k": {
        "position": {
            "x": 3,
            "y": 23,
            "z": 1
        },
        "key": "UrK_k",
        "tag": "badspawn"
    },
    "MvQnq": {
        "position": {
            "x": 4,
            "y": 22,
            "z": 1
        },
        "key": "MvQnq",
        "tag": "badspawn"
    },
    "hQHJY": {
        "position": {
            "x": 5,
            "y": 23,
            "z": 1
        },
        "key": "hQHJY",
        "tag": "badspawn"
    },
    "wjeUU": {
        "position": {
            "x": 4,
            "y": 20,
            "z": 1
        },
        "key": "wjeUU",
        "tag": "badspawn"
    },
    "-tjqL": {
        "position": {
            "x": 7,
            "y": 23,
            "z": 1
        },
        "key": "-tjqL",
        "tag": "badspawn"
    },
    "NJAiU": {
        "position": {
            "x": 8,
            "y": 22,
            "z": 1
        },
        "key": "NJAiU",
        "tag": "badspawn"
    },
    "hcPD2": {
        "position": {
            "x": 11,
            "y": 23,
            "z": 1
        },
        "key": "hcPD2",
        "tag": "badspawn"
    },
    "ervxS": {
        "position": {
            "x": 10,
            "y": 22,
            "z": 1
        },
        "key": "ervxS",
        "tag": "badspawn"
    },
    "SWZ8I": {
        "position": {
            "x": 9,
            "y": 23,
            "z": 1
        },
        "key": "SWZ8I",
        "tag": "badspawn"
    },
    "jQxew": {
        "position": {
            "x": 12,
            "y": 22,
            "z": 1
        },
        "key": "jQxew",
        "tag": "badspawn"
    },
    "CLY0P": {
        "position": {
            "x": 3,
            "y": 21,
            "z": 1
        },
        "key": "CLY0P",
        "tag": "lootspawn"
    },
    "KbEG3": {
        "position": {
            "x": 6,
            "y": 23,
            "z": 1
        },
        "key": "KbEG3",
        "tag": "lootspawn"
    },
    "Aweds": {
        "position": {
            "x": 7,
            "y": 22,
            "z": 1
        },
        "key": "Aweds",
        "tag": "lootspawn"
    },
    "_xwLu": {
        "position": {
            "x": 9,
            "y": 21,
            "z": 1
        },
        "key": "_xwLu",
        "tag": "lootspawn"
    },
    "Bvq9v": {
        "position": {
            "x": 10,
            "y": 20,
            "z": 1
        },
        "key": "Bvq9v",
        "tag": "lootspawn"
    },
    "J0VY9": {
        "position": {
            "x": 11,
            "y": 22,
            "z": 1
        },
        "key": "J0VY9",
        "tag": "lootspawn"
    },
    "6VvTe": {
        "position": {
            "x": 12,
            "y": 23,
            "z": 1
        },
        "key": "6VvTe",
        "tag": "lootspawn"
    },
    "IjJjh": {
        "position": {
            "x": 5,
            "y": 21,
            "z": 1
        },
        "key": "IjJjh",
        "tag": "lootspawn"
    },
    "9ssQT": {
        "position": {
            "x": 9,
            "y": 15,
            "z": 1
        },
        "key": "9ssQT",
        "tag": "torchspawn"
    },
    "38BV7": {
        "position": {
            "x": 5,
            "y": 15,
            "z": 1
        },
        "key": "38BV7",
        "tag": "torchspawn"
    },
    "dKUeC": {
        "position": {
            "x": 3,
            "y": 14,
            "z": 1
        },
        "key": "dKUeC",
        "tag": "torchspawn"
    },
    "5cB7t": {
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "key": "5cB7t",
        "tag": "torchspawn"
    },
    "MT7LR": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "MT7LR",
        "tag": "torchspawn"
    },
    "67PGI": {
        "position": {
            "x": 4,
            "y": 23,
            "z": 1
        },
        "key": "67PGI",
        "tag": "torchspawn"
    },
    "_ICIu": {
        "position": {
            "x": 3,
            "y": 22,
            "z": 1
        },
        "key": "_ICIu",
        "tag": "torchspawn"
    },
    "_d_Oq": {
        "position": {
            "x": 10,
            "y": 23,
            "z": 1
        },
        "key": "_d_Oq",
        "tag": "torchspawn"
    },
    "1iZ4G": {
        "position": {
            "x": 4,
            "y": 2,
            "z": 1
        },
        "key": "1iZ4G",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "by3IY": {
        "position": {
            "x": 5,
            "y": 2,
            "z": 1
        },
        "key": "by3IY",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "QeMUV": {
        "position": {
            "x": 6,
            "y": 2,
            "z": 1
        },
        "key": "QeMUV",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "P9uuf": {
        "position": {
            "x": 7,
            "y": 2,
            "z": 1
        },
        "key": "P9uuf",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "OMI5t": {
        "position": {
            "x": 8,
            "y": 2,
            "z": 1
        },
        "key": "OMI5t",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "QfFnw": {
        "position": {
            "x": 9,
            "y": 2,
            "z": 1
        },
        "key": "QfFnw",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "mDs11": {
        "position": {
            "x": 10,
            "y": 2,
            "z": 1
        },
        "key": "mDs11",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "HxIdc": {
        "position": {
            "x": 11,
            "y": 2,
            "z": 1
        },
        "key": "HxIdc",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "cHVB_": {
        "position": {
            "x": 12,
            "y": 2,
            "z": 1
        },
        "key": "cHVB_",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "w5YI8": {
        "position": {
            "x": 13,
            "y": 3,
            "z": 1
        },
        "key": "w5YI8",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "MCdpU": {
        "position": {
            "x": 13,
            "y": 4,
            "z": 1
        },
        "key": "MCdpU",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Gsjps": {
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "key": "Gsjps",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Ce_KL": {
        "position": {
            "x": 3,
            "y": 2,
            "z": 1
        },
        "key": "Ce_KL",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "GuiA7": {
        "position": {
            "x": 2,
            "y": 3,
            "z": 1
        },
        "key": "GuiA7",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "7-t8_": {
        "position": {
            "x": 2,
            "y": 4,
            "z": 1
        },
        "key": "7-t8_",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "0qwGY": {
        "position": {
            "x": 2,
            "y": 5,
            "z": 1
        },
        "key": "0qwGY",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "8SFQ5": {
        "position": {
            "x": 5,
            "y": 10,
            "z": 1
        },
        "key": "8SFQ5",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "_xecS": {
        "position": {
            "x": 6,
            "y": 10,
            "z": 1
        },
        "key": "_xecS",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "B2Fof": {
        "position": {
            "x": 7,
            "y": 10,
            "z": 1
        },
        "key": "B2Fof",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "hNXkt": {
        "position": {
            "x": 8,
            "y": 10,
            "z": 1
        },
        "key": "hNXkt",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "m7YOq": {
        "position": {
            "x": 10,
            "y": 10,
            "z": 1
        },
        "key": "m7YOq",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "jWheh": {
        "position": {
            "x": 9,
            "y": 10,
            "z": 1
        },
        "key": "jWheh",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "LZK_n": {
        "position": {
            "x": 11,
            "y": 11,
            "z": 1
        },
        "key": "LZK_n",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "VZVpb": {
        "position": {
            "x": 11,
            "y": 12,
            "z": 1
        },
        "key": "VZVpb",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "e51Dk": {
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "key": "e51Dk",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "xh5QY": {
        "position": {
            "x": 13,
            "y": 13,
            "z": 1
        },
        "key": "xh5QY",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "4pZef": {
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "key": "4pZef",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "oJ-Ei": {
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "key": "oJ-Ei",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Ip8io": {
        "position": {
            "x": 12,
            "y": 16,
            "z": 1
        },
        "key": "Ip8io",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Nu4Df": {
        "position": {
            "x": 2,
            "y": 13,
            "z": 1
        },
        "key": "Nu4Df",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "vAxUX": {
        "position": {
            "x": 2,
            "y": 14,
            "z": 1
        },
        "key": "vAxUX",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "uU1oG": {
        "position": {
            "x": 2,
            "y": 15,
            "z": 1
        },
        "key": "uU1oG",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "0A1HY": {
        "position": {
            "x": 4,
            "y": 11,
            "z": 1
        },
        "key": "0A1HY",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "gqtLq": {
        "position": {
            "x": 4,
            "y": 12,
            "z": 1
        },
        "key": "gqtLq",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "A5Rhs": {
        "position": {
            "x": 3,
            "y": 12,
            "z": 1
        },
        "key": "A5Rhs",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "KdH75": {
        "position": {
            "x": 3,
            "y": 16,
            "z": 1
        },
        "key": "KdH75",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "fYMdj": {
        "position": {
            "x": 4,
            "y": 16,
            "z": 1
        },
        "key": "fYMdj",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "rJrX1": {
        "position": {
            "x": 5,
            "y": 16,
            "z": 1
        },
        "key": "rJrX1",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "CsbL7": {
        "position": {
            "x": 6,
            "y": 16,
            "z": 1
        },
        "key": "CsbL7",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "1ax8h": {
        "position": {
            "x": 7,
            "y": 16,
            "z": 1
        },
        "key": "1ax8h",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "cVwPF": {
        "position": {
            "x": 8,
            "y": 16,
            "z": 1
        },
        "key": "cVwPF",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "bRhZB": {
        "position": {
            "x": 10,
            "y": 16,
            "z": 1
        },
        "key": "bRhZB",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "UsXR2": {
        "position": {
            "x": 11,
            "y": 16,
            "z": 1
        },
        "key": "UsXR2",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "JEJNn": {
        "position": {
            "x": 12,
            "y": 19,
            "z": 1
        },
        "key": "JEJNn",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "qIiup": {
        "position": {
            "x": 11,
            "y": 19,
            "z": 1
        },
        "key": "qIiup",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "RH4mo": {
        "position": {
            "x": 9,
            "y": 19,
            "z": 1
        },
        "key": "RH4mo",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Jj7pE": {
        "position": {
            "x": 10,
            "y": 19,
            "z": 1
        },
        "key": "Jj7pE",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "dXAOg": {
        "position": {
            "x": 13,
            "y": 21,
            "z": 1
        },
        "key": "dXAOg",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "cL4GQ": {
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "key": "cL4GQ",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "cym-B": {
        "position": {
            "x": 13,
            "y": 23,
            "z": 1
        },
        "key": "cym-B",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "QvPP4": {
        "position": {
            "x": 12,
            "y": 24,
            "z": 1
        },
        "key": "QvPP4",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "rvckS": {
        "position": {
            "x": 3,
            "y": 24,
            "z": 1
        },
        "key": "rvckS",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "rnj_M": {
        "position": {
            "x": 5,
            "y": 24,
            "z": 1
        },
        "key": "rnj_M",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "JPFNz": {
        "position": {
            "x": 4,
            "y": 24,
            "z": 1
        },
        "key": "JPFNz",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "fDmKX": {
        "position": {
            "x": 6,
            "y": 24,
            "z": 1
        },
        "key": "fDmKX",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "upCE8": {
        "position": {
            "x": 7,
            "y": 24,
            "z": 1
        },
        "key": "upCE8",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "ouAuK": {
        "position": {
            "x": 8,
            "y": 24,
            "z": 1
        },
        "key": "ouAuK",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "-bMwp": {
        "position": {
            "x": 9,
            "y": 24,
            "z": 1
        },
        "key": "-bMwp",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "fv7Q8": {
        "position": {
            "x": 10,
            "y": 24,
            "z": 1
        },
        "key": "fv7Q8",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "dJ-Hk": {
        "position": {
            "x": 11,
            "y": 24,
            "z": 1
        },
        "key": "dJ-Hk",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "l75zh": {
        "position": {
            "x": 2,
            "y": 23,
            "z": 1
        },
        "key": "l75zh",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "bmXkL": {
        "position": {
            "x": 2,
            "y": 22,
            "z": 1
        },
        "key": "bmXkL",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Rtjjf": {
        "position": {
            "x": 2,
            "y": 21,
            "z": 1
        },
        "key": "Rtjjf",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "JRz0N": {
        "position": {
            "x": 2,
            "y": 20,
            "z": 1
        },
        "key": "JRz0N",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "UMDVp": {
        "position": {
            "x": 3,
            "y": 19,
            "z": 1
        },
        "key": "UMDVp",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "zaEVS": {
        "position": {
            "x": 4,
            "y": 19,
            "z": 1
        },
        "key": "zaEVS",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "k0M0J": {
        "position": {
            "x": 5,
            "y": 19,
            "z": 1
        },
        "key": "k0M0J",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "d_n36": {
        "position": {
            "x": 6,
            "y": 19,
            "z": 1
        },
        "key": "d_n36",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "ZEF5B": {
        "position": {
            "x": 7,
            "y": 19,
            "z": 1
        },
        "key": "ZEF5B",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "UZ7Rc": {
        "position": {
            "x": 8,
            "y": 19,
            "z": 1
        },
        "key": "UZ7Rc",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "o9HNp": {
        "position": {
            "x": 20,
            "y": 8,
            "z": 1
        },
        "key": "o9HNp",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "f3MNb": {
        "position": {
            "x": 19,
            "y": 7,
            "z": 1
        },
        "key": "f3MNb",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "wh88R": {
        "position": {
            "x": 19,
            "y": 6,
            "z": 1
        },
        "key": "wh88R",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "__4U-": {
        "position": {
            "x": 19,
            "y": 5,
            "z": 1
        },
        "key": "__4U-",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "YMJwP": {
        "position": {
            "x": 20,
            "y": 4,
            "z": 1
        },
        "key": "YMJwP",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "mH3D2": {
        "position": {
            "x": 21,
            "y": 3,
            "z": 1
        },
        "key": "mH3D2",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Asvk7": {
        "position": {
            "x": 22,
            "y": 2,
            "z": 1
        },
        "key": "Asvk7",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "kXsDc": {
        "position": {
            "x": 23,
            "y": 2,
            "z": 1
        },
        "key": "kXsDc",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "WMN8U": {
        "position": {
            "x": 24,
            "y": 2,
            "z": 1
        },
        "key": "WMN8U",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "8o3X1": {
        "position": {
            "x": 25,
            "y": 2,
            "z": 1
        },
        "key": "8o3X1",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "jnmkW": {
        "position": {
            "x": 26,
            "y": 2,
            "z": 1
        },
        "key": "jnmkW",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "5eRPr": {
        "position": {
            "x": 27,
            "y": 2,
            "z": 1
        },
        "key": "5eRPr",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Vu_qE": {
        "position": {
            "x": 28,
            "y": 3,
            "z": 1
        },
        "key": "Vu_qE",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "GkaMW": {
        "position": {
            "x": 29,
            "y": 4,
            "z": 1
        },
        "key": "GkaMW",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "g9Vof": {
        "position": {
            "x": 30,
            "y": 5,
            "z": 1
        },
        "key": "g9Vof",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "JqVZd": {
        "position": {
            "x": 30,
            "y": 6,
            "z": 1
        },
        "key": "JqVZd",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "hB3e8": {
        "position": {
            "x": 30,
            "y": 7,
            "z": 1
        },
        "key": "hB3e8",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Q3tSI": {
        "position": {
            "x": 29,
            "y": 8,
            "z": 1
        },
        "key": "Q3tSI",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "oaSok": {
        "position": {
            "x": 26,
            "y": 8,
            "z": 1
        },
        "key": "oaSok",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "71_lW": {
        "position": {
            "x": 25,
            "y": 8,
            "z": 1
        },
        "key": "71_lW",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "g-SrF": {
        "position": {
            "x": 24,
            "y": 8,
            "z": 1
        },
        "key": "g-SrF",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "nG-7G": {
        "position": {
            "x": 23,
            "y": 8,
            "z": 1
        },
        "key": "nG-7G",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "StaID": {
        "position": {
            "x": 22,
            "y": 8,
            "z": 1
        },
        "key": "StaID",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "sARz3": {
        "position": {
            "x": 21,
            "y": 8,
            "z": 1
        },
        "key": "sARz3",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "3ai2F": {
        "position": {
            "x": 27,
            "y": 8,
            "z": 1
        },
        "key": "3ai2F",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "bb9Km": {
        "position": {
            "x": 28,
            "y": 8,
            "z": 1
        },
        "key": "bb9Km",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "j0vPT": {
        "position": {
            "x": 36,
            "y": 7,
            "z": 1
        },
        "key": "j0vPT",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "MTsTE": {
        "position": {
            "x": 36,
            "y": 6,
            "z": 1
        },
        "key": "MTsTE",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "5-rzi": {
        "position": {
            "x": 36,
            "y": 5,
            "z": 1
        },
        "key": "5-rzi",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "L8N6Q": {
        "position": {
            "x": 36,
            "y": 4,
            "z": 1
        },
        "key": "L8N6Q",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "eWSj3": {
        "position": {
            "x": 36,
            "y": 3,
            "z": 1
        },
        "key": "eWSj3",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "1f7Xz": {
        "position": {
            "x": 37,
            "y": 2,
            "z": 1
        },
        "key": "1f7Xz",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "hhiv4": {
        "position": {
            "x": 38,
            "y": 2,
            "z": 1
        },
        "key": "hhiv4",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "L1tjG": {
        "position": {
            "x": 39,
            "y": 2,
            "z": 1
        },
        "key": "L1tjG",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Bl5j1": {
        "position": {
            "x": 40,
            "y": 2,
            "z": 1
        },
        "key": "Bl5j1",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "729Gq": {
        "position": {
            "x": 41,
            "y": 2,
            "z": 1
        },
        "key": "729Gq",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "INnJr": {
        "position": {
            "x": 42,
            "y": 2,
            "z": 1
        },
        "key": "INnJr",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "5KWaw": {
        "position": {
            "x": 43,
            "y": 2,
            "z": 1
        },
        "key": "5KWaw",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "oxSvy": {
        "position": {
            "x": 44,
            "y": 2,
            "z": 1
        },
        "key": "oxSvy",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "pCNqw": {
        "position": {
            "x": 45,
            "y": 2,
            "z": 1
        },
        "key": "pCNqw",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "FYcSc": {
        "position": {
            "x": 46,
            "y": 2,
            "z": 1
        },
        "key": "FYcSc",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "D3QcQ": {
        "position": {
            "x": 47,
            "y": 3,
            "z": 1
        },
        "key": "D3QcQ",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "Gek4H": {
        "position": {
            "x": 47,
            "y": 4,
            "z": 1
        },
        "key": "Gek4H",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "3JVn4": {
        "position": {
            "x": 47,
            "y": 5,
            "z": 1
        },
        "key": "3JVn4",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "4KtcI": {
        "position": {
            "x": 47,
            "y": 6,
            "z": 1
        },
        "key": "4KtcI",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "gOygC": {
        "position": {
            "x": 47,
            "y": 7,
            "z": 1
        },
        "key": "gOygC",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "5NFZW": {
        "position": {
            "x": 46,
            "y": 8,
            "z": 1
        },
        "key": "5NFZW",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "6Y1_c": {
        "position": {
            "x": 45,
            "y": 8,
            "z": 1
        },
        "key": "6Y1_c",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "NER5O": {
        "position": {
            "x": 44,
            "y": 8,
            "z": 1
        },
        "key": "NER5O",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "NKsHC": {
        "position": {
            "x": 43,
            "y": 8,
            "z": 1
        },
        "key": "NKsHC",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "e-CYs": {
        "position": {
            "x": 42,
            "y": 8,
            "z": 1
        },
        "key": "e-CYs",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "fBRFx": {
        "position": {
            "x": 41,
            "y": 8,
            "z": 1
        },
        "key": "fBRFx",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "lYhU9": {
        "position": {
            "x": 40,
            "y": 8,
            "z": 1
        },
        "key": "lYhU9",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "36Yxq": {
        "position": {
            "x": 39,
            "y": 8,
            "z": 1
        },
        "key": "36Yxq",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "aRgcA": {
        "position": {
            "x": 38,
            "y": 8,
            "z": 1
        },
        "key": "aRgcA",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "6tCou": {
        "position": {
            "x": 37,
            "y": 8,
            "z": 1
        },
        "key": "6tCou",
        "tag": "badspawnspawn", "hasCollision": true
    },
    "hz1Y_": {
        "position": {
            "x": 38,
            "y": 7,
            "z": 1
        },
        "key": "hz1Y_",
        "tag": "badspawn"
    },
    "HCWBU": {
        "position": {
            "x": 37,
            "y": 5,
            "z": 1
        },
        "key": "HCWBU",
        "tag": "badspawn"
    },
    "s0cSK": {
        "position": {
            "x": 39,
            "y": 6,
            "z": 1
        },
        "key": "s0cSK",
        "tag": "badspawn"
    },
    "t6JTM": {
        "position": {
            "x": 39,
            "y": 5,
            "z": 1
        },
        "key": "t6JTM",
        "tag": "badspawn"
    },
    "TTi-7": {
        "position": {
            "x": 27,
            "y": 7,
            "z": 1
        },
        "key": "TTi-7",
        "tag": "badspawn"
    },
    "TqZuN": {
        "position": {
            "x": 28,
            "y": 7,
            "z": 1
        },
        "key": "TqZuN",
        "tag": "badspawn"
    },
    "bJ854": {
        "position": {
            "x": 29,
            "y": 6,
            "z": 1
        },
        "key": "bJ854",
        "tag": "badspawn"
    },
    "C7RNE": {
        "position": {
            "x": 28,
            "y": 5,
            "z": 1
        },
        "key": "C7RNE",
        "tag": "badspawn"
    },
    "5D_Dq": {
        "position": {
            "x": 26,
            "y": 4,
            "z": 1
        },
        "key": "5D_Dq",
        "tag": "badspawn"
    },
    "aCv5b": {
        "position": {
            "x": 25,
            "y": 6,
            "z": 1
        },
        "key": "aCv5b",
        "tag": "badspawn"
    },
    "UJElF": {
        "position": {
            "x": 24,
            "y": 7,
            "z": 1
        },
        "key": "UJElF",
        "tag": "badspawn"
    },
    "6bdMW": {
        "position": {
            "x": 22,
            "y": 7,
            "z": 1
        },
        "key": "6bdMW",
        "tag": "badspawn"
    },
    "LIL7N": {
        "position": {
            "x": 21,
            "y": 7,
            "z": 1
        },
        "key": "LIL7N",
        "tag": "badspawn"
    },
    "WXr4H": {
        "position": {
            "x": 20,
            "y": 6,
            "z": 1
        },
        "key": "WXr4H",
        "tag": "badspawn"
    },
    "rZUyF": {
        "position": {
            "x": 21,
            "y": 5,
            "z": 1
        },
        "key": "rZUyF",
        "tag": "badspawn"
    },
    "YjFZq": {
        "position": {
            "x": 21,
            "y": 4,
            "z": 1
        },
        "key": "YjFZq",
        "tag": "badspawn"
    },
    "FgjQx": {
        "position": {
            "x": 23,
            "y": 4,
            "z": 1
        },
        "key": "FgjQx",
        "tag": "badspawn"
    },
    "AdWPj": {
        "position": {
            "x": 22,
            "y": 6,
            "z": 1
        },
        "key": "AdWPj",
        "tag": "badspawn"
    },
    "7fVG1": {
        "position": {
            "x": 23,
            "y": 3,
            "z": 1
        },
        "key": "7fVG1",
        "tag": "goodspawn"
    },
    "Kyzo3": {
        "position": {
            "x": 24,
            "y": 3,
            "z": 1
        },
        "key": "Kyzo3",
        "tag": "goodspawn"
    },
    "b3Pjo": {
        "position": {
            "x": 25,
            "y": 3,
            "z": 1
        },
        "key": "b3Pjo",
        "tag": "goodspawn"
    },
    "mcBSk": {
        "position": {
            "x": 26,
            "y": 3,
            "z": 1
        },
        "key": "mcBSk",
        "tag": "goodspawn"
    },
    "8Y1Uh": {
        "position": {
            "x": 40,
            "y": 7,
            "z": 1
        },
        "key": "8Y1Uh",
        "tag": "goodspawn"
    },
    "cqojq": {
        "position": {
            "x": 41,
            "y": 7,
            "z": 1
        },
        "key": "cqojq",
        "tag": "goodspawn"
    },
    "fzKsj": {
        "position": {
            "x": 42,
            "y": 7,
            "z": 1
        },
        "key": "fzKsj",
        "tag": "goodspawn"
    },
    "s_y6G": {
        "position": {
            "x": 43,
            "y": 7,
            "z": 1
        },
        "key": "s_y6G",
        "tag": "goodspawn"
    },
    "S_RIp": {
        "position": {
            "x": 24,
            "y": 6,
            "z": 1
        },
        "key": "S_RIp",
        "tag": "torchspawn"
    },
    "b7-Bf": {
        "position": {
            "x": 22,
            "y": 5,
            "z": 1
        },
        "key": "b7-Bf",
        "tag": "torchspawn"
    },
    "7wBXW": {
        "position": {
            "x": 27,
            "y": 5,
            "z": 1
        },
        "key": "7wBXW",
        "tag": "torchspawn"
    },
    "REvI-": {
        "position": {
            "x": 21,
            "y": 6,
            "z": 1
        },
        "key": "REvI-",
        "tag": "lootspawn"
    },
    "0UI-o": {
        "position": {
            "x": 23,
            "y": 6,
            "z": 1
        },
        "key": "0UI-o",
        "tag": "lootspawn"
    },
    "mhJyh": {
        "position": {
            "x": 24,
            "y": 4,
            "z": 1
        },
        "key": "mhJyh",
        "tag": "lootspawn"
    },
    "PoLVK": {
        "position": {
            "x": 25,
            "y": 4,
            "z": 1
        },
        "key": "PoLVK",
        "tag": "lootspawn"
    },
    "yIELl": {
        "position": {
            "x": 26,
            "y": 5,
            "z": 1
        },
        "key": "yIELl",
        "tag": "lootspawn"
    },
    "-DecH": {
        "position": {
            "x": 27,
            "y": 6,
            "z": 1
        },
        "key": "-DecH",
        "tag": "lootspawn"
    },
    "yigtf": {
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        },
        "key": "yigtf",
        "tag": "lootspawn"
    },
    "iTUjk": {
        "position": {
            "x": 6,
            "y": 5,
            "z": 1
        },
        "key": "iTUjk",
        "tag": "lootspawn"
    },
    "AmGgX": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "AmGgX",
        "tag": "lootspawn"
    },
    "7K3CQ": {
        "position": {
            "x": 40,
            "y": 6,
            "z": 1
        },
        "key": "7K3CQ",
        "tag": "lootspawn"
    },
    "EdzWl": {
        "position": {
            "x": 39,
            "y": 4,
            "z": 1
        },
        "key": "EdzWl",
        "tag": "torchspawn"
    },
    "Y8MbV": {
        "position": {
            "x": 44,
            "y": 4,
            "z": 1
        },
        "key": "Y8MbV",
        "tag": "torchspawn"
    },
    "WIgtT": {
        "position": {
            "x": 38,
            "y": 5,
            "z": 1
        },
        "key": "WIgtT",
        "tag": "torchspawn"
    },
    "P9gsd": {
        "position": {
            "x": 45,
            "y": 5,
            "z": 1
        },
        "key": "P9gsd",
        "tag": "torchspawn"
    },
    "Xzko9": {
        "position": {
            "x": 45,
            "y": 4,
            "z": 1
        },
        "key": "Xzko9",
        "tag": "badspawn"
    },
    "Pky4M": {
        "position": {
            "x": 42,
            "y": 6,
            "z": 1
        },
        "key": "Pky4M",
        "tag": "badspawn"
    },
    "GX6Yt": {
        "position": {
            "x": 42,
            "y": 4,
            "z": 1
        },
        "key": "GX6Yt",
        "tag": "badspawn"
    },
    "_8FmH": {
        "position": {
            "x": 41,
            "y": 5,
            "z": 1
        },
        "key": "_8FmH",
        "tag": "badspawn"
    },
    "d0-6o": {
        "position": {
            "x": 38,
            "y": 3,
            "z": 1
        },
        "key": "d0-6o",
        "tag": "badspawn"
    },
    "7Hx75": {
        "position": {
            "x": 41,
            "y": 3,
            "z": 1
        },
        "key": "7Hx75",
        "tag": "badspawn"
    },
    "eBoQ_": {
        "position": {
            "x": 43,
            "y": 3,
            "z": 1
        },
        "key": "eBoQ_",
        "tag": "badspawn"
    },
    "DGOqT": {
        "position": {
            "x": 40,
            "y": 3,
            "z": 1
        },
        "key": "DGOqT",
        "tag": "badspawn"
    },
    "YcoaX": {
        "position": {
            "x": 45,
            "y": 3,
            "z": 1
        },
        "key": "YcoaX",
        "tag": "badspawn"
    },
    "YvoJZ": {
        "position": {
            "x": 37,
            "y": 4,
            "z": 1
        },
        "key": "YvoJZ",
        "tag": "badspawn"
    },
    "B5PbO": {
        "position": {
            "x": 38,
            "y": 6,
            "z": 1
        },
        "key": "B5PbO",
        "tag": "lootspawn"
    },
    "AEGBk": {
        "position": {
            "x": 43,
            "y": 6,
            "z": 1
        },
        "key": "AEGBk",
        "tag": "lootspawn"
    },
    "lnB9B": {
        "position": {
            "x": 43,
            "y": 5,
            "z": 1
        },
        "key": "lnB9B",
        "tag": "lootspawn"
    },
    "tdPoM": {
        "position": {
            "x": 40,
            "y": 5,
            "z": 1
        },
        "key": "tdPoM",
        "tag": "lootspawn"
    },
    "_nAt9": {
        "position": {
            "x": 41,
            "y": 4,
            "z": 1
        },
        "key": "_nAt9",
        "tag": "lootspawn"
    },
    "yIwL7": {
        "position": {
            "x": 42,
            "y": 5,
            "z": 1
        },
        "key": "yIwL7",
        "tag": "lootspawn"
    },
    "-W5tH": {
        "position": {
            "x": 38,
            "y": 4,
            "z": 1
        },
        "key": "-W5tH",
        "tag": "lootspawn"
    },
    "63av-": {
        "position": {
            "x": 40,
            "y": 4,
            "z": 1
        },
        "key": "63av-",
        "tag": "lootspawn"
    },
    "RX1i6": {
        "position": {
            "x": 44,
            "y": 5,
            "z": 1
        },
        "key": "RX1i6",
        "tag": "lootspawn"
    },
    "ErikI": {
        "position": {
            "x": 45,
            "y": 6,
            "z": 1
        },
        "key": "ErikI",
        "tag": "lootspawn"
    },
    "gHr_E": {
        "position": {
            "x": 10,
            "y": 5,
            "z": 1
        },
        "key": "gHr_E",
        "tag": "torchspawn"
    },
    "KdKJ9": {
        "position": {
            "x": 11,
            "y": 5,
            "z": 1
        },
        "key": "KdKJ9",
        "tag": "lootspawn"
    },
    "qzagA": {
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "key": "qzagA",
        "tag": "torchspawn"
    },
    "3KQWU": {
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        },
        "key": "3KQWU",
        "tag": "badspawn"
    },
    "us064": {
        "position": {
            "x": 4,
            "y": 5,
            "z": 1
        },
        "key": "us064",
        "tag": "badspawn"
    }
}
